import { render } from "./FractionsBox.vue?vue&type=template&id=95cd421e&scoped=true&ts=true"
import script from "./FractionsBox.vue?vue&type=script&lang=ts"
export * from "./FractionsBox.vue?vue&type=script&lang=ts"

import "./FractionsBox.vue?vue&type=style&index=0&id=95cd421e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95cd421e"]])

export default __exports__